import React from 'react'
import Step from './step'
import CertificationModal from './certificationModal'
class TimeLine extends React.Component {
  constructor(props) {
    super(props)
    // this.state = {
    //   index: 0,
    // }
  }
  render() {
    const {alert}=this.props
    const Homedata=this.props.Homedata
    const path=this.props.path
    return (
      <div className="timeline">
        { Homedata.map((item)=>{
       
         return <Step key={item.lid} 
          title={item.title}
          description={item.description}
          imageView={item.imageView}
          imageNotView={item.imageNotView}
          id={item.id}
          lid={item.lid}
          direction={item.direction}
          path={path}/>
        })
        }
        {/* <Step
          title="第1章 產品簡介"
          description="本章將教你如何安裝FineReport，並了解其功能。"
          imageView={introduce}
          imageNotView={notintroduce}
          id={this.state.index + 1}
          lid={5}
          direction="left"
        />
        <Step
          title="第2章 報表設計"
          description="本章將教你開發不同格式的報表，並自訂樣式效果。"
          imageNotView={notreportDesign}
          imageView={reportDesign}
          id={this.state.index + 2}
          lid={6}
          direction="right"
        />
        <Step
          title="第3章 報表分組分頁分欄"
          description="本章將教你設定報表分組、分頁、分欄，讓資料更直觀。"
          id={this.state.index + 3}
          lid={7}
          imageView={group}
          imageNotView={notgroup}
          direction="left"
        />
        <Step
          title="第4章 參數介紹"
          description="本章將教你報表參數的應用，實現資料過濾、下鑽等效果。"
          id={this.state.index + 4}
          lid={8}
          imageNotView={notparameter}
          imageView={parameter}
          direction="right"
        />
        <Step
          title="第5章 圖表設計"
          description="本章將教你透過五十多種圖表實現資料的視覺化展現，分析資料的變化趨勢或異常。"
          id={this.state.index + 5}
          lid={9}
          imageView={picture}
          imageNotView={notpicture}
          direction="left"
        />
        <Step
          title="第6章 填報應用"
          description="本章將教你如何實現資料的採集並寫入資料庫中。"
          id={this.state.index + 6}
          lid={10}
          imageView={fillFunction}
          imageNotView={notfillFunction}
          direction="right"
        />
        <Step
          title="第7章 決策報表"
          description="本章將教你透過組件的拖曳快速實現大屛的製作。"
          id={this.state.index + 7}
          lid={11}
          imageView={designerReport}
          imageNotView={notdesignerReport}
          direction="left"
        /> */}
         { alert?<CertificationModal />:null}
      </div>
    )
  }
}
export default TimeLine
